// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--1_djD";
export var primary = "button-module--primary--3Ifat";
export var outline = "button-module--outline--20bwn";
export var sm = "button-module--sm--3dl2m";
export var spinner = "button-module--spinner--1sd7S";
export var lg = "button-module--lg--1PUQ9";
export var center = "button-module--center--2hNCp";